import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {SectionKey} from "../utils/branchDiff";
import {MigratableRecord} from "../utils/migrateRecord";

// Returns the live (mutable) collection for a diff section, initializing it
// on the model if absent so commands can write into legacy data that lacks
// the array.
export function ensureSectionCollection(
    data: RemoteConstantsModel,
    sectionKey: SectionKey,
): MigratableRecord[] | undefined {
    switch (sectionKey) {
        case 'unitAttributes':
            if (!data.unitAttributes) data.unitAttributes = [];
            return data.unitAttributes;
        case 'buildingAttributes':
            if (!data.buildingAttributes) data.buildingAttributes = [];
            return data.buildingAttributes;
        case 'techActionAttributes':
            if (!data.techActionAttributes) data.techActionAttributes = [];
            return data.techActionAttributes;
        case 'techPassiveAttributes':
            if (!data.techPassiveAttributes) data.techPassiveAttributes = [];
            return data.techPassiveAttributes;
        case 'rewards':
            if (!data.rewards) data.rewards = [];
            return data.rewards;
        case 'units':
            if (!data.units) data.units = [];
            return data.units;
        case 'buildings':
            if (!data.buildings) data.buildings = [];
            return data.buildings;
        case 'tiles':
            if (!data.tiles) data.tiles = [];
            return data.tiles;
        case 'resources':
            if (!data.resources) data.resources = [];
            return data.resources;
        case 'techTree':
            if (!data.techTree) data.techTree = [];
            return data.techTree;
        default:
            return undefined;
    }
}
